const FJSpeechServiceLanguageConfig = [
    {
        key: 'af-ZA',
        languageKey: 'af-za-speech-service',
        text: 'Afrikaans (South Africa)',
    },
    {
        key: 'sq-AL',
        languageKey: 'sq-al-speech-service',
        text: 'Albanian (Albania)',
    },
    {
        key: 'am-ET',
        languageKey: 'am-et-speech-service',
        text: 'Amharic (Ethiopia)',
    },
    {
        key: 'ar-DZ',
        languageKey: 'ar-dz-speech-service',
        text: 'Arabic (Algeria)',
    },
    {
        key: 'ar-BH',
        languageKey: 'ar-bh-speech-service',
        text: 'Arabic (Bahrain)',
    },
    {
        key: 'ar-EG',
        languageKey: 'ar-eg-speech-service',
        text: 'Arabic (Egypt)',
    },
    {
        key: 'ar-IQ',
        languageKey: 'ar-iq-speech-service',
        text: 'Arabic (Iraq)',
    },
    {
        key: 'ar-IL',
        languageKey: 'ar-il-speech-service',
        text: 'Arabic (Israel)',
    },
    {
        key: 'ar-JO',
        languageKey: 'ar-jo-speech-service',
        text: 'Arabic (Jordan)',
    },
    {
        key: 'ar-KW',
        languageKey: 'ar-kw-speech-service',
        text: 'Arabic (Kuwait)',
    },
    {
        key: 'ar-LB',
        languageKey: 'ar-lb-speech-service',
        text: 'Arabic (Lebanon)',
    },
    {
        key: 'ar-LY',
        languageKey: 'ar-ly-speech-service',
        text: 'Arabic (Libya)',
    },
    {
        key: 'ar-MA',
        languageKey: 'ar-ma-speech-service',
        text: 'Arabic (Morocco)',
    },
    {
        key: 'ar-OM',
        languageKey: 'ar-om-speech-service',
        text: 'Arabic (Oman)',
    },
    {
        key: 'ar-PS',
        languageKey: 'ar-ps-speech-service',
        text: 'Arabic (Palestinian Territories)',
    },
    {
        key: 'ar-QA',
        languageKey: 'ar-qa-speech-service',
        text: 'Arabic (Qatar)',
    },
    {
        key: 'ar-SA',
        languageKey: 'ar-sa-speech-service',
        text: 'Arabic (Saudi Arabia)',
    },
    {
        key: 'ar-SY',
        languageKey: 'ar-sy-speech-service',
        text: 'Arabic (Syria)',
    },
    {
        key: 'ar-TN',
        languageKey: 'ar-tn-speech-service',
        text: 'Arabic (Tunisia)',
    },
    {
        key: 'ar-AE',
        languageKey: 'ar-ae-speech-service',
        text: 'Arabic (United Arab Emirates)',
    },
    {
        key: 'ar-YE',
        languageKey: 'ar-ye-speech-service',
        text: 'Arabic (Yemen)',
    },
    {
        key: 'hy-AM',
        languageKey: 'hy-am-speech-service',
        text: 'Armenian (Armenia)',
    },
    {
        key: 'az-AZ',
        languageKey: 'az-az-speech-service',
        text: 'Azerbaijani (Azerbaijan)',
    },
    {
        key: 'eu-ES',
        languageKey: 'eu-es-speech-service',
        text: 'Basque',
    },
    {
        key: 'bn-IN',
        languageKey: 'bn-in-speech-service',
        text: 'Bengali (India)',
    },
    {
        key: 'bs-BA',
        languageKey: 'bs-ba-speech-service',
        text: 'Bosnian (Bosnia)',
    },
    {
        key: 'bg-BG',
        languageKey: 'bg-bg-speech-service',
        text: 'Bulgarian (Bulgaria)',
    },
    {
        key: 'my-MM',
        languageKey: 'my-mm-speech-service',
        text: 'Burmese (Myanmar)',
    },
    {
        key: 'ca-ES',
        languageKey: 'ca-es-speech-service',
        text: 'Catalan (Spain)',
    },
    {
        key: 'yue-CN',
        languageKey: 'yue-cn-speech-service',
        text: 'Chinese (Cantonese, Simplified)',
    },
    {
        key: 'zh-HK',
        languageKey: 'zh-hk-speech-service',
        text: 'Chinese (Cantonese, Traditional)',
    },
    {
        key: 'zh-CN',
        languageKey: 'zh-cn-speech-service',
        text: 'Chinese (Mandarin, Simplified)',
    },
    {
        key: 'zh-CN-SICHUAN',
        languageKey: 'zh-cn-sichuan-speech-service',
        text: 'Chinese (Southwestern Mandarin, Simplified)',
    },
    {
        key: 'zh-TW',
        languageKey: 'zh-tw-speech-service',
        text: 'Chinese (Taiwanese Mandarin)',
    },
    {
        key: 'wuu-CN',
        languageKey: 'wuu-cn-speech-service',
        text: 'Chinese (Wu, Simplified)',
    },
    {
        key: 'hr-HR',
        languageKey: 'hr-hr-speech-service',
        text: 'Croatian (Croatia)',
    },
    {
        key: 'cs-CZ',
        languageKey: 'cs-cz-speech-service',
        text: 'Czech (Czech)',
    },
    {
        key: 'da-DK',
        languageKey: 'da-dk-speech-service',
        text: 'Danish (Denmark)',
    },
    {
        key: 'nl-BE',
        languageKey: 'nl-be-speech-service',
        text: 'Dutch (Belgium)',
    },
    {
        key: 'nl-NL',
        languageKey: 'nl-nl-speech-service',
        text: 'Dutch (Netherlands)',
    },
    {
        key: 'en-AU',
        languageKey: 'en-au-speech-service',
        text: 'English (Australia)',
    },
    {
        key: 'en-CA',
        languageKey: 'en-ca-speech-service',
        text: 'English (Canada)',
    },
    {
        key: 'en-GH',
        languageKey: 'en-gh-speech-service',
        text: 'English (Ghana)',
    },
    {
        key: 'en-HK',
        languageKey: 'en-hk-speech-service',
        text: 'English (Hongkong)',
    },
    {
        key: 'en-IN',
        languageKey: 'en-in-speech-service',
        text: 'English (India)',
    },
    {
        key: 'en-IE',
        languageKey: 'en-ie-speech-service',
        text: 'English (Ireland)',
    },
    {
        key: 'en-KE',
        languageKey: 'en-ke-speech-service',
        text: 'English (Kenya)',
    },
    {
        key: 'en-NZ',
        languageKey: 'en-nz-speech-service',
        text: 'English (New Zealand)',
    },
    {
        key: 'en-NG',
        languageKey: 'en-ng-speech-service',
        text: 'English (Nigeria)',
    },
    {
        key: 'en-PH',
        languageKey: 'en-ph-speech-service',
        text: 'English (Philippines)',
    },
    {
        key: 'en-SG',
        languageKey: 'en-sg-speech-service',
        text: 'English (Singapore)',
    },
    {
        key: 'en-ZA',
        languageKey: 'en-za-speech-service',
        text: 'English (South Africa)',
    },
    {
        key: 'en-TZ',
        languageKey: 'en-tz-speech-service',
        text: 'English (Tanzania)',
    },
    {
        key: 'en-GB',
        languageKey: 'en-gb-speech-service',
        text: 'English (United Kingdom)',
    },
    {
        key: 'en-US',
        languageKey: 'en-us-speech-service',
        text: 'English (United States)',
    },
    {
        key: 'et-EE',
        languageKey: 'et-ee-speech-service',
        text: 'Estonian (Estonia)',
    },
    {
        key: 'fil-PH',
        languageKey: 'fil-ph-speech-service',
        text: 'Filipino (Philippines)',
    },
    {
        key: 'fi-FI',
        languageKey: 'fi-fi-speech-service',
        text: 'Finnish (Finland)',
    },
    {
        key: 'fr-BE',
        languageKey: 'fr-be-speech-service',
        text: 'French (Belgium)',
    },
    {
        key: 'fr-CA',
        languageKey: 'fr-ca-speech-service',
        text: 'French (Canada)',
    },
    {
        key: 'fr-FR',
        languageKey: 'fr-fr-speech-service',
        text: 'French (France)',
    },
    {
        key: 'fr-CH',
        languageKey: 'fr-ch-speech-service',
        text: 'French (Switzerland)',
    },
    {
        key: 'gl-ES',
        languageKey: 'gl-es-speech-service',
        text: 'Galician',
    },
    {
        key: 'ka-GE',
        languageKey: 'ka-ge-speech-service',
        text: 'Georgian (Georgia)',
    },
    {
        key: 'de-AT',
        languageKey: 'de-at-speech-service',
        text: 'German (Austria)',
    },
    {
        key: 'de-DE',
        languageKey: 'de-de-speech-service',
        text: 'German (Germany)',
    },
    {
        key: 'de-CH',
        languageKey: 'de-ch-speech-service',
        text: 'German (Switzerland)',
    },
    {
        key: 'el-GR',
        languageKey: 'el-gr-speech-service',
        text: 'Greek (Greece)',
    },
    {
        key: 'gu-IN',
        languageKey: 'gu-in-speech-service',
        text: 'Gujarati (India)',
    },
    {
        key: 'he-IL',
        languageKey: 'he-il-speech-service',
        text: 'Hebrew (Israel)',
    },
    {
        key: 'hi-IN',
        languageKey: 'hi-in-speech-service',
        text: 'Hindi (India)',
    },
    {
        key: 'hu-HU',
        languageKey: 'hu-hu-speech-service',
        text: 'Hungarian (Hungary)',
    },
    {
        key: 'is-IS',
        languageKey: 'is-is-speech-service',
        text: 'Icelandic (Iceland)',
    },
    {
        key: 'id-ID',
        languageKey: 'id-id-speech-service',
        text: 'Indonesian (Indonesia)',
    },
    {
        key: 'ga-IE',
        languageKey: 'ga-ie-speech-service',
        text: 'Irish (Ireland)',
    },
    {
        key: 'it-IT',
        languageKey: 'it-it-speech-service',
        text: 'Italian (Italy)',
    },
    {
        key: 'it-CH',
        languageKey: 'it-ch-speech-service',
        text: 'Italian (Switzerland)',
    },
    {
        key: 'ja-JP',
        languageKey: 'ja-jp-speech-service',
        text: 'Japanese (Japan)',
    },
    {
        key: 'jv-ID',
        languageKey: 'jv-id-speech-service',
        text: 'Javanese (Indonesia)',
    },
    {
        key: 'kn-IN',
        languageKey: 'kn-in-speech-service',
        text: 'Kannada (India)',
    },
    {
        key: 'kk-KZ',
        languageKey: 'kk-kz-speech-service',
        text: 'Kazakh (Kazakhstan)',
    },
    {
        key: 'km-KH',
        languageKey: 'km-kh-speech-service',
        text: 'Khmer (Cambodia)',
    },
    {
        key: 'ko-KR',
        languageKey: 'ko-kr-speech-service',
        text: 'Korean (Korea)',
    },
    {
        key: 'lo-LA',
        languageKey: 'lo-la-speech-service',
        text: 'Lao (Laos)',
    },
    {
        key: 'lv-LV',
        languageKey: 'lv-lv-speech-service',
        text: 'Latvian (Latvia)',
    },
    {
        key: 'lt-LT',
        languageKey: 'lt-lt-speech-service',
        text: 'Lithuanian (Lithuania)',
    },
    {
        key: 'mk-MK',
        languageKey: 'mk-mk-speech-service',
        text: 'Macedonian (Republic of North Macedonia)',
    },
    {
        key: 'ms-MY',
        languageKey: 'ms-my-speech-service',
        text: 'Malay (Malaysia)',
    },
    {
        key: 'ml-IN',
        languageKey: 'ml-in-speech-service',
        text: 'Malayalam (India)',
    },
    {
        key: 'mt-MT',
        languageKey: 'mt-mt-speech-service',
        text: 'Maltese (Malta)',
    },
    {
        key: 'mr-IN',
        languageKey: 'mr-in-speech-service',
        text: 'Marathi (India)',
    },
    {
        key: 'mn-MN',
        languageKey: 'mn-mn-speech-service',
        text: 'Mongolian (Mongolia)',
    },
    {
        key: 'ne-NP',
        languageKey: 'ne-np-speech-service',
        text: 'Nepali (Nepal)',
    },
    {
        key: 'nb-NO',
        languageKey: 'nb-no-speech-service',
        text: 'Norwegian (Bokmål, Norway)',
    },
    {
        key: 'ps-AF',
        languageKey: 'ps-af-speech-service',
        text: 'Pashto (Afghanistan)',
    },
    {
        key: 'fa-IR',
        languageKey: 'fa-ir-speech-service',
        text: 'Persian (Iran)',
    },
    {
        key: 'pl-PL',
        languageKey: 'pl-pl-speech-service',
        text: 'Polish (Poland)',
    },
    {
        key: 'pt-BR',
        languageKey: 'pt-br-speech-service',
        text: 'Portuguese (Brazil)',
    },
    {
        key: 'pt-PT',
        languageKey: 'pt-pt-speech-service',
        text: 'Portuguese (Portugal)',
    },
    {
        key: 'ro-RO',
        languageKey: 'ro-ro-speech-service',
        text: 'Romanian (Romania)',
    },
    {
        key: 'ru-RU',
        languageKey: 'ru-ru-speech-service',
        text: 'Russian (Russia)',
    },
    {
        key: 'sr-RS',
        languageKey: 'sr-rs-speech-service',
        text: 'Serbian (Serbia)',
    },
    {
        key: 'si-LK',
        languageKey: 'si-lk-speech-service',
        text: 'Sinhala (Sri Lanka)',
    },
    {
        key: 'sk-SK',
        languageKey: 'sk-sk-speech-service',
        text: 'Slovak (Slovakia)',
    },
    {
        key: 'sl-SI',
        languageKey: 'sl-si-speech-service',
        text: 'Slovenian (Slovenia)',
    },
    {
        key: 'so-SO',
        languageKey: 'so-so-speech-service',
        text: 'Somali (Somalia)',
    },
    {
        key: 'es-AR',
        languageKey: 'es-ar-speech-service',
        text: 'Spanish (Argentina)',
    },
    {
        key: 'es-BO',
        languageKey: 'es-bo-speech-service',
        text: 'Spanish (Bolivia)',
    },
    {
        key: 'es-CL',
        languageKey: 'es-cl-speech-service',
        text: 'Spanish (Chile)',
    },
    {
        key: 'es-CO',
        languageKey: 'es-co-speech-service',
        text: 'Spanish (Colombia)',
    },
    {
        key: 'es-CR',
        languageKey: 'es-cr-speech-service',
        text: 'Spanish (Costa Rica)',
    },
    {
        key: 'es-CU',
        languageKey: 'es-cu-speech-service',
        text: 'Spanish (Cuba)',
    },
    {
        key: 'es-DO',
        languageKey: 'es-do-speech-service',
        text: 'Spanish (Dominican Republic)',
    },
    {
        key: 'es-EC',
        languageKey: 'es-ec-speech-service',
        text: 'Spanish (Ecuador)',
    },
    {
        key: 'es-SV',
        languageKey: 'es-sv-speech-service',
        text: 'Spanish (El Salvador)',
    },
    {
        key: 'es-GQ',
        languageKey: 'es-gq-speech-service',
        text: 'Spanish (Equatorial Guinea)',
    },
    {
        key: 'es-GT',
        languageKey: 'es-gt-speech-service',
        text: 'Spanish (Guatemala)',
    },
    {
        key: 'es-HN',
        languageKey: 'es-hn-speech-service',
        text: 'Spanish (Honduras)',
    },
    {
        key: 'es-MX',
        languageKey: 'es-mx-speech-service',
        text: 'Spanish (Mexico)',
    },
    {
        key: 'es-NI',
        languageKey: 'es-ni-speech-service',
        text: 'Spanish (Nicaragua)',
    },
    {
        key: 'es-PA',
        languageKey: 'es-pa-speech-service',
        text: 'Spanish (Panama)',
    },
    {
        key: 'es-PY',
        languageKey: 'es-py-speech-service',
        text: 'Spanish (Paraguay)',
    },
    {
        key: 'es-PE',
        languageKey: 'es-pe-speech-service',
        text: 'Spanish (Peru)',
    },
    {
        key: 'es-PR',
        languageKey: 'es-pr-speech-service',
        text: 'Spanish (Puerto Rico)',
    },
    {
        key: 'es-ES',
        languageKey: 'es-es-speech-service',
        text: 'Spanish (Spain)',
    },
    {
        key: 'es-US',
        languageKey: 'es-us-speech-service',
        text: 'Spanish (United States)',
    },
    {
        key: 'es-UY',
        languageKey: 'es-uy-speech-service',
        text: 'Spanish (Uruguay)',
    },
    {
        key: 'es-VE',
        languageKey: 'es-ve-speech-service',
        text: 'Spanish (Venezuela)',
    },
    {
        key: 'sw-KE',
        languageKey: 'sw-ke-speech-service',
        text: 'Swahili (Kenya)',
    },
    {
        key: 'sw-TZ',
        languageKey: 'sw-tz-speech-service',
        text: 'Swahili (Tanzania)',
    },
    {
        key: 'sv-SE',
        languageKey: 'sv-se-speech-service',
        text: 'Swedish (Sweden)',
    },
    {
        key: 'ta-IN',
        languageKey: 'ta-in-speech-service',
        text: 'Tamil (India)',
    },
    {
        key: 'te-IN',
        languageKey: 'te-in-speech-service',
        text: 'Telugu (India)',
    },
    {
        key: 'th-TH',
        languageKey: 'th-th-speech-service',
        text: 'Thai (Thailand)',
    },
    {
        key: 'tr-TR',
        languageKey: 'tr-tr-speech-service',
        text: 'Turkish (Turkey)',
    },
    {
        key: 'uk-UA',
        languageKey: 'uk-ua-speech-service',
        text: 'Ukrainian (Ukraine)',
    },
    {
        key: 'uz-UZ',
        languageKey: 'uz-uz-speech-service',
        text: 'Uzbek (Uzbekistan)',
    },
    {
        key: 'vi-VN',
        languageKey: 'vi-vn-speech-service',
        text: 'Vietnamese (Vietnam)',
    },
    {
        key: 'cy-GB',
        languageKey: 'cy-gb-speech-service',
        text: 'Welsh (United Kingdom)',
    },
    {
        key: 'zu-ZA',
        languageKey: 'zu-za-speech-service',
        text: 'Zulu (South Africa)',
    },
];

const FJRelationBetweenSpeechServiceAndLocalization = {
    de: 'de-DE',
    fr: 'fr-FR',
    pt: 'pt-PT',
    jp: 'ja-JP',
    es: 'es-ES',
    en: 'en-US',
    cn: 'zh-CN',
    tw: 'zh-TW',
    ar: 'ar-SA',
};

/**
 * @description 文字转语音默认角色修改，并且对应的声音应该置顶
 * @type {{de: string, tw: string, pt: string, jp: string, en: string, cn: string, fr: string, es: string}}
 */
const FJVoiceBetweenSpeechServiceAndLocalization = {
    de: 'de-DE-ConradNeural',
    fr: 'fr-FR-DeniseNeural',
    pt: '',
    jp: 'ja-JP-NanamiNeural',
    es: '',
    en: 'en-US-JennyNeural',
    cn: 'zh-CN-XiaoxiaoNeural',
    tw: '',
    ar: '',
};

export {
    FJSpeechServiceLanguageConfig,
    FJRelationBetweenSpeechServiceAndLocalization,
    FJVoiceBetweenSpeechServiceAndLocalization,
};
